// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P06T","icon":"styles_icon__3YRZw"};